import React from "react";
import { Trash } from "react-bootstrap-icons";

import AddItemButton from 'components/Buttons/AddItemButton';
import TagsList from "components/Tags/TagsList"

const FormData = ({
    form,
    onInputChange,
    onItemRemove,
    onSubmit,
    onCancel,
    setActiveSection,
    setForm
}) => {
    const TITLE_MAX_LENGTH = 60;

    const handleRemoveValue = (uid) => {
        onItemRemove('value', uid)
    }

    const handleRemoveTag = (uid) => {
        onItemRemove('tag', uid)
    }

    const handleValueRemove = (index) => {
        setForm(prev => ({
            ...prev,
            values: prev.values.filter((_, i) => i !== index)
        }));
    };

    return (
        <div className="card container-height">
            <form id="tagsForm" className="d-flex flex-column h-100" onSubmit={onSubmit}>
                <div className="card-header form-card-header-paddings no-background no-border">
                    <div className="p-2">
                        <h3>{form.uid ? 'Edit Chart' : 'New Chart'}</h3>
                    </div>
                </div>

                <div className="card-body form-card-body-paddings overflow-auto">
                    <div className="mb-2">
                        <div className="d-flex justify-content-between">
                            <label htmlFor="title" className="form-label">Title</label>
                            <small className="text-muted">
                                {form.title.length}/{TITLE_MAX_LENGTH}
                            </small>
                        </div>
                        <input
                            type="text"
                            id="title"
                            name="title"
                            value={form.title}
                            onChange={onInputChange}
                            className="form-control"
                            maxLength={TITLE_MAX_LENGTH}
                            required
                        />
                    </div>

                    <div className="mb-2">
                        <h5>Tags</h5>

                        <TagsList
                            items={form.tags}
                            onDeleteHandler={handleRemoveTag}
                        />
                        
                        <AddItemButton onClick={() => setActiveSection('tags')} />
                    </div>

                    <div className="mb-2">
                        <h5>Value</h5>

                        <ul className="list-group list-group-flush w-100">
                            {form.values.map((item, index) => {
                                return (
                                    <li
                                        key={index}
                                        className="list-group-item w-100 p-1"

                                    >
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                            padding: '4px'
                                        }}>
                                            <div className="d-flex flex-column">
                                                <span className="badge bg-secondary align-self-start">{item.type}</span>
                                                <span>{item.name}{item.payload?.unit && <span className="text-muted small ms-1">({item.payload.unit})</span>}</span>
                                            </div>

                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => handleValueRemove(index)}
                                            >
                                                <Trash size={16} />
                                            </button>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                            
                        {form.values.length < 1 && (
                            <AddItemButton onClick={() => setActiveSection('values')} />
                        )}
                        
                    </div>
                </div>

                <div className="card-footer form-card-footer-paddings border-top no-background">
                    <div className="d-flex justify-content-between">
                        <button
                            type="submit"
                            className="btn btn-success"
                        >
                            {form.uid ? 'Save' : 'Add'}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={onCancel}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default FormData;
